import { umamiTrackEvent } from 'utils/umami'
import { openreplaySetMetadata } from 'utils/openreplay'

const STORAGE_KEY = 'umamiQrTracked'

/**
 * Report a QR-code entry (?qr=1).
 * Sends a `qr-scan` event to Umami and tags the OpenReplay session with the
 * `qr` flag. (venue/venueName OpenReplay metadata is set centrally in
 * utils/venueOpenReplayMeta, for all sessions — not just QR ones.)
 * Deduped per tab session: the same venue + table is only reported once
 * (refresh / in-app navigation must not double-count).
 * Call this once venue data has loaded so the friendly venue name is available.
 * @param {Object} route resolved current route (this.$route)
 * @param {String} [venueName] friendly venue name (e.g. "I Love Paris Bistro")
 */
/**
 * 上报二维码入口访问(?qr=1)。
 * 向 Umami 发 `qr-scan` 事件,并给 OpenReplay session 打 `qr` 标记。
 * (venue/venueName 的 OpenReplay metadata 由 utils/venueOpenReplayMeta 统一设置,覆盖全部会话。)
 * 同一标签页会话内同一 venue+桌号只上报一次
 * (刷新/页内跳转不重复计数)。
 * 在餐厅数据加载完成后调用,以便带上人类可读的餐厅全名。
 * @param {Object} route 已解析的当前路由(this.$route)
 * @param {String} [venueName] 餐厅全名(如 "I Love Paris Bistro")
 */
function trackQrScan(route, venueName) {
  if (route.query.qr !== '1') return

  const venue = route.params.venueId || ''
  const table = route.params.number || ''

  const signature = `${venue}|${table}`
  if (sessionStorage.getItem(STORAGE_KEY) === signature) return
  sessionStorage.setItem(STORAGE_KEY, signature)

  const isTakeout = route.path.startsWith('/online/') || route.path.startsWith('/v/o/')
  const mode = isTakeout ? 'takeout' : (table ? 'dine-in' : 'pickup')

  const payload = { venue, mode }
  if (table) payload.table = table
  if (venueName) payload.venueName = venueName
  umamiTrackEvent('qr-scan', payload)

  // venue/venueName 的 OpenReplay metadata 现由 utils/venueOpenReplayMeta 统一负责(全会话每店只发一次);
  // 这里只标记本会话是扫码入口。OpenReplay 未启动时安全 no-op。
  openreplaySetMetadata('qr', '1')
}

export { trackQrScan }
